// packages/constants/src/inputs/clientErrorReport.ts

/**
 * Length caps of a `ClientErrorReport` (POST /v1/businesses/{bizId}/client-errors).
 * Shared by the embed's sender, which slices every string to these lengths
 * (packages/storefront/src/translation/reportWidgetError.ts), AND the API's Zod schema,
 * which rejects anything longer (apps/api/src/lib/v1/schemas/clientErrorReport.ts)
 * — so a conforming report is never rejected, and nobody can fill the log.
 */
export const CLIENT_ERROR_REPORT_LIMITS = {
  kind: 64,
  message: 300,
  stack: 2000,
  componentStack: 2000,
  url: 500,
  userAgent: 500,
  deployId: 64,
  widget: 32,
  htmlLang: 35,
  /** Entries in `details.guard` (the DOM guard's counters, flattened). */
  guardEntries: 40,
  guardKey: 64,
  guardString: 200,
} as const;
